// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Item_attributes_SalvarAtributosCategoriaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/item_attributes/salvar_atributos_categoria/{category_id}
 *
 * Bulk replace attribute bindings for a service category.
 *
 * Required:
 *   - attributes (So_CategoryAttributeBindingInputRow[]) — each entry must
 *     contain attribute_id; required and display_order default to 0.
 */
import type { So_CategoryAttributeBindingInputRow } from './So_CategoryAttributeBindingInputRow'
import { registerContract } from './validate'

export interface Item_attributes_SalvarAtributosCategoriaInput {
attributes?: So_CategoryAttributeBindingInputRow[]
}

registerContract('Item_attributes_SalvarAtributosCategoriaInput', {
  attributes: {
    type: 'array',
    required: false,
    items: {
      attribute_id:   { type: 'number',  required: true },
      required:       { type: 'number',  required: false },
      display_order:  { type: 'number',  required: false },
      report_type:    { type: 'string',  required: false },
      is_description: { type: 'number',  required: false },
    },
  },
})
